import { connect } from 'react-redux'
import { actions, actionTypes } from '@bt-react/store'
import get from 'lodash/get'
import AttachmentsLists from './AttachmentsLists'

const mapStateToProps = (state: any, props: any) => {

    const { channelId, webcastId } = props
    const webcast = state.webcast.collection[`${channelId}${webcastId}`]

    return {
        webcastData: webcast && get(webcast, 'status.hasData') && webcast.data,
        status: state.resources && state.resources.status,
        activeResource: state.resources && state.resources.activeResource
    }

}

const mapDispatchToProps = (dispatch: any) => ({
    setView: (view: string) =>
        dispatch(actions.resource.setAttachmentView(view)),
    rearrangeResource: (channelId: string, webcastId: string, data: any) =>
        dispatch(actions.resource.rearrangeResource(channelId, webcastId, data)),
    deleteResource: (channelId: any, webcastId: any, attachmentId: any, origin?: string) =>
        dispatch(actions.resource.deleteResource(channelId, webcastId, attachmentId, origin))
})

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsLists)